import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Account } from '@/core/api/entities/account/account'

interface SelectedAccountState {
	selectedAccount: Account | null
}

const initialState: SelectedAccountState = {
	selectedAccount: null,
}

export const SELECTED_ACCOUNT_ID_KEY = 'selected_account_id'

const selectedAccountSlice = createSlice({
	name: 'selectedAccount',
	initialState,
	reducers: {
		setSelectedAccount: (state, action: PayloadAction<Account | null>) => {
			state.selectedAccount = action.payload
			if (action.payload?.id) {
				localStorage.setItem(SELECTED_ACCOUNT_ID_KEY, String(action.payload.id))
			}
		},
		clearSelectedAccount: (state) => {
			state.selectedAccount = null
			localStorage.removeItem(SELECTED_ACCOUNT_ID_KEY)
		},
	},
	extraReducers: (builder) => {
		// Reset in-memory selected account whenever a new session starts or ends.
		// Use action type strings to avoid a circular import with the auth slice.
		builder.addMatcher(
			(action) =>
				action.type === 'auth/loginSuccess' || action.type === 'auth/logout',
			(state) => {
				state.selectedAccount = null
			}
		)
	},
})

export const { setSelectedAccount, clearSelectedAccount } =
	selectedAccountSlice.actions

export const selectedAccountReducer = selectedAccountSlice.reducer
